export const MAX_CHAR_NEWS = 5000;
